export function getListingGroupUrl(id: string) {
    return `/messaging/group/${id}`;
}

export function getMessagingListingUrl(id: string) {
    return `/messaging/${id}`;
}
